import React, { useState, useEffect } from 'react'
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { AddNewsAndEventsAPI } from '../redux/actions/NewsAndEvents/AddNewsAndEventsAction';
import { useDispatch, useSelector } from 'react-redux';
import { addNewsAndEventsStateReset } from '../redux/slices/NewsAndEvents/AddNewsAndEventsSlice';
import { useNavigate } from 'react-router-dom';

const NewsAndEvents = () => {

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [validationErrors, setValidationErrors] = useState('');
    const [images, setImages] = useState([]);

    const { response: AddNewsAndEventsResponse, error: AddNewsAndEventsError } = useSelector((state) => state.addNewsAndEvents);

    const validateForm = () => {
        const newErrors = {};
        if (!title.trim()) newErrors.title = true;
        if (!description.trim()) newErrors.description = true;

        setValidationErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);

        if (files.length > 1 || images.length >= 1) {
            showErrorToast("Only one image is allowed to be uploaded.");
            // alert("Only one image is allowed to be uploaded.");
            return;
        }

        const file = files[0];

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}`);
            // alert(`Invalid file type: ${file.name}`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            // alert(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        const preview = {
            file,
            url: URL.createObjectURL(file),
        };

        setImages([preview]);
    };

    const handleRemoveImage = () => {
        setImages([]);
    };


    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);

        if (files.length > 1 || images.length >= 1) {
            showErrorToast("Only one image is allowed to be uploaded.");
            return;
        }

        const file = files[0];

        if (!allowedTypes.includes(file.type)) {
            showErrorToast(`Invalid file type: ${file.name}`);
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            showErrorToast(`File ${file.name} exceeds 2MB size limit.`);
            return;
        }

        const preview = {
            file,
            url: URL.createObjectURL(file),
        };

        setImages([preview]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;

        const formData = new FormData();
        if (images.length > 0) {
            formData.append('image', images[0].file);
        }

        formData.append('title', title);
        formData.append('until', 0)
        formData.append('description', description);

        // const payload = {
        //     title: title,
        //     description: description,
        //     until: null
        // }

        try {
            await dispatch(AddNewsAndEventsAPI(formData));
            // console.log('Form submitted', formData);
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    }

    const resetFormFields = () => {
        setImages([]);
        setDescription('');
        setTitle('');
        setValidationErrors('');
    };

    useEffect(() => {
        if (AddNewsAndEventsResponse?.status === true) {
            showSuccessToast(AddNewsAndEventsResponse?.message);
            resetFormFields();
            dispatch(addNewsAndEventsStateReset());
            navigate('/admin-dashboard/news-and-events-management')
        }
    }, [AddNewsAndEventsResponse])

    useEffect(() => {
        if (AddNewsAndEventsError) {
            showErrorToast(AddNewsAndEventsError?.data);
            dispatch(addNewsAndEventsStateReset())
        }
    }, [AddNewsAndEventsError])

    return (
        <div className='content_section'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-10'>
                        <div className='row gy-4'>
                            <div className='col-md-7'>
                                <div className='input_wrapper'>
                                    <label>Title</label>
                                    <div className='form_field'>
                                        <input type='text' className={`form-control ${validationErrors.title ? 'is-invalid' : ''}`} placeholder='Enter your title' value={title} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setTitle(value);
                                            if (validationErrors.title) {
                                                setValidationErrors(prev => ({ ...prev, title: false }));
                                            }
                                        }} />
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-7'>
                                <div className='input_wrapper'>
                                    <label>Upload Image</label>
                                    <div className='form_field form_field_upload' onDrop={handleDrop}
                                        onDragOver={handleDragOver}>
                                        <input type="file" className='d-none' id='uploadImg' onChange={handleFileChange} accept="image/jpeg, image/png, image/jpg, image/webp, image/svg+xml" />
                                        <label htmlFor='uploadImg'>
                                            <span><img src='/assets/icons/upload-icon.svg' /></span>
                                            <span>Drag or drop here</span>
                                            <span>or</span>
                                            <span className='primary_text'>Browse</span>
                                        </label>
                                    </div>
                                    <span className="required_info">Maximum 2MB image size and only accepted jpeg, png, jpg, gif, svg, webp Maximum upload limit is 10.</span>
                                    <div className='image-preview-list mt-3 d-flex flex-wrap gap-2'>
                                        {images.map((img, index) => (
                                            <div key={index} className='preview-img-box position-relative'>
                                                <img
                                                    src={img.url}
                                                    alt={`preview-${index}`}
                                                    style={{
                                                        width: '80px',
                                                        height: '80px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        border: '1px solid #ddd',
                                                    }}
                                                />
                                                <button
                                                    type='button'
                                                    onClick={() => handleRemoveImage(index)}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-6px',
                                                        right: '-6px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '12px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className='col-md-7'>
                                <div className='input_wrapper'>
                                    <label>Description</label>
                                    <div className='form_field'>
                                        <textarea className={`form-control ${validationErrors.description ? 'is-invalid' : ''}`} placeholder='Write Something.....' rows={6} value={description} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setDescription(value);
                                            if (validationErrors.description) {
                                                setValidationErrors(prev => ({ ...prev, description: false }));
                                            }
                                        }}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12'>
                                <div className='hstack gap-3 mt-4'>
                                    <button className='primary-btn' onClick={handleSubmit}>Save</button>
                                    <button className='transparent-btn' onClick={resetFormFields}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* <edit modal> */}

            <div className="modal fade" id="editNewsAndEventsModal" tabIndex={- 1} aria-labelledby="editNewsAndEventsModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body detail-modal-body">
                            <div className='modal-field mb-2'>
                                <div className="input_wrapper">
                                    <label>Title</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.title ? 'is-invalid' : ''}`} placeholder="Enter title" value={title} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setTitle(value);
                                            if (validationErrors.title) {
                                                setValidationErrors(prev => ({ ...prev, title: false }));
                                            }
                                        }} />
                                    </div>
                                </div>
                                <div className="input_wrapper">
                                    <label>Title</label>
                                    <div className="form_field">
                                        <input type="text" className={`form-control ${validationErrors.description ? 'is-invalid' : ''}`} placeholder="Enter description" value={description} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setDescription(value);
                                            if (validationErrors.description) {
                                                setValidationErrors(prev => ({ ...prev, description: false }));
                                            }
                                        }} />
                                    </div>
                                </div>

                                <div className='modal_btn d-flex justify-content-end gap-2 p-0 mt-4'>
                                    <button className='transparent-btn fs-14 py-2' onClick={resetFormFields}>Cancel</button>
                                    <button className='primary-btn fs-14 py-2' onClick={handleSubmit}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </edit> */}

        </div>
    )
}

export default NewsAndEvents